module.exports = __webpack_public_path__ + "static/media/product_3.7ebebd31.png";